export default __webpack_public_path__ + "static/media/1793.cf7a5df3.png";